if (!customElements.get('popup-form-modal')) {
  class PopupFormModal extends HTMLElement {
    constructor() {
      super();

      this.closeButton = this.querySelector('[id^="ModalClose-"]');
      this.overlay = this.querySelector('.popup-form-modal__overlay');
      this.dialog = this.querySelector('[role="dialog"]');
      this.triggerHash = this.dataset.triggerHash || '#trade-program-popup';
      this.openedBy = null;

      this.closeButton?.addEventListener('click', () => this.hide());
      this.overlay?.addEventListener('click', () => this.hide());

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    connectedCallback() {
      // Move to body to avoid z-index stacking context issues
      if (!this.moved) {
        this.moved = true;
        document.body.appendChild(this);
      }

      // Listen for hash-based trigger clicks
      document.addEventListener('click', this.handleTriggerClick.bind(this));

      // Check if page loaded with the trigger hash
      if (window.location.hash === this.triggerHash) {
        // Small delay to let the page settle
        requestAnimationFrame(() => this.show());
      }

      // Auto-open
      const autoOpenDelay = this.dataset.autoOpen;
      if (autoOpenDelay !== undefined) {
        const delay = parseInt(autoOpenDelay, 10) * 1000;
        const storageKey = `popup-form-dismissed-${this.id}`;
        if (!sessionStorage.getItem(storageKey)) {
          this.autoOpenTimer = setTimeout(() => this.show(), delay);
        }
      }
    }

    disconnectedCallback() {
      if (this.autoOpenTimer) clearTimeout(this.autoOpenTimer);
    }

    handleTriggerClick(event) {
      const trigger = event.target.closest(`a[href="${this.triggerHash}"], [href="${this.triggerHash}"]`);
      if (!trigger) return;

      event.preventDefault();
      this.show(trigger);
    }

    show(opener) {
      if (this.hasAttribute('open')) return;

      this.openedBy = opener || null;
      this.setAttribute('open', '');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');

      trapFocus(this, this.dialog);

      if (typeof pauseAllMedia === 'function') {
        pauseAllMedia();
      } else if (window.pauseAllMedia) {
        window.pauseAllMedia();
      }
    }

    hide() {
      if (!this.hasAttribute('open')) return;

      this.removeAttribute('open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');

      removeTrapFocus(this.openedBy);
      this.openedBy = null;

      // Mark as dismissed for auto-open
      const storageKey = `popup-form-dismissed-${this.id}`;
      sessionStorage.setItem(storageKey, '1');

      // Clean hash from URL if present
      if (window.location.hash === this.triggerHash) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }

      document.body.dispatchEvent(new CustomEvent('modalClosed'));
    }
  }

  customElements.define('popup-form-modal', PopupFormModal);
}
